module.exports = __webpack_public_path__ + "img/宣传_184.2137702a.jpg";